import axios from 'axios'

export default {
  namespaced: true,

  state: {
    adminSessionSetting: {}
  },

  mutations: {
    SET_SETTING (state, data) {
      state.adminSessionSetting = data
    }
  },

  getters: {},

  actions: {
    async getAdminSessionSetting ({ commit }) {
      try {
        const result = await axios.get('/settings/default')
        result.data.setting_json = typeof result.data.setting_json === 'string'
          ? JSON.parse(result.data.setting_json)
          : result.data.setting_json

        commit('SET_SETTING', result.data)
      } catch (e) {
        console.log(e)
      }
    },

    async updateAdminSessionSetting ({ commit }, params) {
      try {
        const response = await axios.patch('/settings/default/admin/session', params)
        return response
      } catch (err) {
        console.log(err)
      }
    }
  }
}
